export default {
    msg: {
        cancelledToken: 'cancelled request by token',
        jwtExpired: 'TokenExpiredError: jwt expired',
    },
}
